import React from 'react';
import './footer.css';

function Footer() {
    return (
        <footer className="footer">
            <p>Copywrite &copy; 2021 Josh Almostt. All rights reserved.</p>
        </footer>
    )
}

export default Footer;